module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("qkEZD"))).then(() => parcelRequire('hEqeo'));